// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"oo_a bhl_qt bhl_a bhl_w","FaqAskQuestion__outdated":"oo_b bhl_vr bhl_xg"};